import React from 'react';
import styled from 'styled-components';
import { CheckoutPackage } from './CheckoutPackage';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { StepForm } from './StepForm';

import { FinalStep } from './FinalStep';

const Wrapper = styled.div`
  background: url(${props => props.bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${props => props.currentStep === 3 ? '#151F41' : 'transparent'};
  min-height: 50rem;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;

export const StepWrapper = ({ title, dispatch, parentState, bg }) => {
  const { tvCount, packageInfo, orderNumber, currentStep } = parentState;

  const steps = [
    <Step1
      dispatch={dispatch}
      tvCount={tvCount}
      isInternetOnly={packageInfo.isOnlyInternet}
    />,
    <Step2
      dispatch={dispatch}
      packageInfo={packageInfo}
    />,
    <StepForm
      dispatch={dispatch}
      parentState={parentState}
    />
  ];

  return (<>
    <Wrapper bg={bg} currentStep={currentStep}>
      {currentStep === 3 ? (
        <FinalStep
        />
      ) : (
          <div className='container px-0 py-5 w-100'>
            {/* <SectionTitle>
              <h1>{title}</h1>
              <hr className='center mb-5' />
            </SectionTitle> */}
            <div className='row my-5 w-100 d-flex'>
              <div className='col-12 col-lg-7 mt-5 mt-lg-0 order-1 order-lg-0'>
                {steps[currentStep]}
              </div>
              <div className='col-12 col-lg-5 mt-5 mt-lg-0 order-0 order-lg-1'>
                <h2 className='mb-5'>Избран пакет</h2>
                <CheckoutPackage
                  packageInfo={packageInfo}
                  orderNumber={orderNumber}
                />
              </div>
            </div>
          </div>
        )}
    </Wrapper>
  </>);
};

export const numberChecker = (value) => {
  return /^\d*$/.test(value) &&
    (value === "" || (parseInt(value) > 0 && parseInt(value) <= 5));
}
